export function formatName(fullName = "") {
  if (!fullName) return "";

  // If the name contains any numbers, return it as is
  if (/\d/.test(fullName)) {
    return fullName.trim();
  }

  const parts = fullName.trim().split(" ");
  if (parts.length === 1) return parts[0]; // Only first name present

  const firstName = parts[0];
  const lastName = parts[parts.length - 1]; // Handles multiple words in name
  const shortLastName = lastName.slice(0, 1);

  return `${firstName} ${shortLastName}.`;
}